import { Globe, User, Calendar, Sparkles } from 'lucide-react';

export const ViewToggle = ({ view, onViewChange, isPatreonMember = false }) => {
  return (
    <div className="flex flex-wrap bg-zinc-900 rounded-lg p-1 border border-zinc-800 gap-1" data-testid="view-toggle">
      <button
        onClick={() => onViewChange('all')}
        data-testid="view-all-btn"
        className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
          view === 'all'
            ? 'bg-zinc-700 text-zinc-100'
            : 'text-zinc-400 hover:text-zinc-200'
        }`}
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">All Signals</span>
        <span className="sm:hidden">All</span>
      </button>
      {/* Hide "My Signals" for Patreon members */}
      {!isPatreonMember && (
        <button
          onClick={() => onViewChange('my')}
          data-testid="view-my-btn"
          className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
            view === 'my'
              ? 'bg-zinc-700 text-zinc-100'
              : 'text-zinc-400 hover:text-zinc-200'
          }`}
        >
          <User className="w-4 h-4" />
          <span className="hidden sm:inline">My Signals</span>
          <span className="sm:hidden">Mine</span>
        </button>
      )}
      <button
        onClick={() => onViewChange('today')}
        data-testid="view-today-btn"
        className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
          view === 'today'
            ? 'bg-zinc-700 text-zinc-100'
            : 'text-zinc-400 hover:text-zinc-200'
        }`}
      >
        <Calendar className="w-4 h-4" />
        <span>Today</span>
      </button>
      <button
        onClick={() => onViewChange('reset')}
        data-testid="view-reset-btn"
        className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
          view === 'reset'
            ? 'bg-zinc-700 text-zinc-100'
            : 'text-zinc-400 hover:text-zinc-200'
        }`}
      >
        <Sparkles className="w-4 h-4" />
        <span>Reset</span>
      </button>
    </div>
  );
};
